import { NgModule } from '@angular/core';

import { AcSelectOptionDirective } from './ac-select-option.directive';
import { ClickOutsideDirective } from './click-outside.directive';
import { CurrencyInputDirective } from './currency-input.directive';
import { ForcedLineBreakDirective } from './forced-line-break.directive';
import { HasPortfolioTypeDirective } from './has-portfolio-type.directive';
import { IconDirective } from './icon.directive';
import { MeasureChildElementsDirective } from './measure-child-elements.directive';
import { MultiViewComponentDirective } from './multi-view-component.directive';
import { NgForTrackByFieldsDirective } from './ng-for-track-by-fields.directive';
import { RemoteImageDirective } from './remote-image.directive';
import { TouchGesturesDirective } from './touch-gestures.directive';

@NgModule({
	declarations: [
		HasPortfolioTypeDirective,
		AcSelectOptionDirective,
		ClickOutsideDirective,
		CurrencyInputDirective,
		ForcedLineBreakDirective,
		IconDirective,
		RemoteImageDirective,
		MeasureChildElementsDirective,
		MultiViewComponentDirective,
		NgForTrackByFieldsDirective,
		TouchGesturesDirective
	],
	exports: [
		HasPortfolioTypeDirective,
		AcSelectOptionDirective,
		ClickOutsideDirective,
		CurrencyInputDirective,
		ForcedLineBreakDirective,
		IconDirective,
		RemoteImageDirective,
		MeasureChildElementsDirective,
		MultiViewComponentDirective,
		NgForTrackByFieldsDirective,
		TouchGesturesDirective
	]
})
export class GenericDirectivesModule { }
